import { useAppSelector } from '../../store/hooks'
import { selectAccountId } from '../../store/auth/authSlice'
import { useGetMeQuery, useUpdateUserIntegrationMutation } from '../../store/user/user'
import { IntegrationServiceId } from '../../common/integrations'
import { removeEmptyItems } from '../../common/util'
import { merge } from './utils'

export const useSaveIntegrationServiceConfig = (serviceId: IntegrationServiceId) => {
  const accountId = useAppSelector(selectAccountId)
  const { data: userData } = useGetMeQuery({ accountId })
  const [updateUserIntegration, { isLoading: isSaving }] = useUpdateUserIntegrationMutation()

  const saveServiceConfig = async (serviceConfigPatch: Record<string, unknown>) => {
    try {
      const integration = userData?.integrations?.find((i) => i.serviceId === serviceId)
      if (!integration) {
        return
      }
      const mergedServiceConfig = merge(integration.serviceConfig || {}, serviceConfigPatch)
      await updateUserIntegration({
        accountId,
        integrationName: integration.serviceId,
        integrationId: integration.id,
        payload: { serviceConfig: removeEmptyItems(mergedServiceConfig) },
      })
    } catch (e) {
      console.error(e)
    }
  }

  return { saveServiceConfig, isSaving }
}
